module.exports = "<ag-contact-history\n  [service]=\"companyApiService\"\n  [referenceId]=\"companyId\"\n></ag-contact-history>\n"